var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapModesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "8 7 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1455_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19.5C8 16.1848 9.31696 13.0054 11.6612 10.6612C14.0054 8.31696 17.1848 7 20.5 7C23.8152 7 26.9946 8.31696 29.3388 10.6612C31.683 13.0054 33 16.1848 33 19.5C33 22.8152 31.683 25.9946 29.3388 28.3388C26.9946 30.683 23.8152 32 20.5 32C17.1848 32 14.0054 30.683 11.6612 28.3388C9.31696 25.9946 8 22.8152 8 19.5ZM19.7188 8.68281C18.6719 9.00156 17.6328 9.96406 16.7703 11.5812C16.4863 12.119 16.2419 12.6767 16.0391 13.25H19.7188V8.68281ZM14.3906 13.25C14.6513 12.4201 14.986 11.6153 15.3906 10.8453C15.6626 10.3355 15.9745 9.84804 16.3234 9.3875C14.3877 10.1907 12.7222 11.531 11.5234 13.25H14.3906ZM13.4812 18.7188C13.5281 17.3484 13.6969 16.0344 13.9688 14.8125H10.6156C10.0345 16.0397 9.68686 17.3643 9.59063 18.7188H13.4812ZM15.5734 14.8125C15.2661 16.0934 15.0892 17.4022 15.0453 18.7188H19.7188V14.8125H15.5734ZM21.2812 14.8125V18.7188H25.9531C25.9098 17.4022 25.7334 16.0935 25.4266 14.8125H21.2812ZM15.0469 20.2812C15.0902 21.5978 15.2666 22.9065 15.5734 24.1875H19.7188V20.2812H15.0469ZM21.2812 20.2812V24.1875H25.4266C25.7188 22.9922 25.9047 21.675 25.9547 20.2812H21.2812ZM16.0391 25.75C16.2557 26.3542 16.4995 26.9104 16.7703 27.4187C17.6328 29.0359 18.6734 29.9969 19.7188 30.3172V25.75H16.0391ZM16.3234 29.6125C15.9745 29.152 15.6626 28.6645 15.3906 28.1547C14.986 27.3847 14.6513 26.5799 14.3906 25.75H11.5234C12.7203 27.4708 14.3864 28.8115 16.3234 29.6125ZM13.9688 24.1875C13.6866 22.9032 13.5234 21.5955 13.4812 20.2812H9.59063C9.6875 21.6719 10.0453 22.9891 10.6156 24.1875H13.9688ZM24.6766 29.6125C26.6136 28.8115 28.2797 27.4708 29.4766 25.75H26.6094C26.3487 26.5799 26.014 27.3847 25.6094 28.1547C25.3374 28.6645 25.0255 29.152 24.6766 29.6125ZM21.2812 25.75V30.3172C22.3281 29.9984 23.3672 29.0359 24.2297 27.4187C24.5005 26.9115 24.7443 26.3552 24.9609 25.75H21.2812ZM27.0312 24.1875H30.3844C30.9547 22.9891 31.3125 21.6719 31.4094 20.2812H27.5187C27.4766 21.5955 27.3134 22.9032 27.0312 24.1875ZM31.4094 18.7188C31.3131 17.3643 30.9655 16.0397 30.3844 14.8125H27.0312C27.3031 16.0344 27.4719 17.3484 27.5187 18.7188H31.4094ZM25.6094 10.8453C25.9953 11.5703 26.3312 12.3766 26.6094 13.25H29.4766C28.2797 11.5292 26.6136 10.1885 24.6766 9.3875C25.0172 9.83125 25.3297 10.3219 25.6094 10.8453ZM24.9609 13.25C24.7581 12.6767 24.5137 12.119 24.2297 11.5812C23.3672 9.96406 22.3281 9.00312 21.2812 8.68281V13.25H24.9609Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1455_98",
    x: -2,
    y: -3,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.447059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1455_98"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1455_98",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapModesIcon);
export default __webpack_public_path__ + "static/media/MapModesIcon.51b46f9bdaf01aef539da859d4c6f1cc.svg";
export { ForwardRef as ReactComponent };